// ToggleSwitch.jsx
import React from 'react'
import styled from 'styled-components'
import { CrossIcon, TickIcon } from 'shared-ui/assets'

const Switch = styled.div`
    width: 52px;
    height: 32px;
    background: ${(props) => (props.isEnabled ? '#5CB617' : '#666666')};
    border-radius: 100px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0px 3px;
    justify-content: ${(props) =>
        props.isEnabled ? 'flex-end' : 'flex-start'};
    transition:
        background 0.3s ease,
        justify-content 0.3s ease;
    border: ${(props) =>
        props.isEnabled ? '2px solid transparent' : '2px solid #CCCCCC'};
`

const Knob = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${(props) => (props.isEnabled ? '#FFFFFF' : '#CCCCCC')};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`

export default function ToggleSwitch({ isEnabled, onToggle }) {
    return (
        <Switch isEnabled={isEnabled} onClick={onToggle}>
            <Knob isEnabled={isEnabled}>
                <img
                    style={{ width: '12px', height: '12px' }}
                    src={isEnabled ? TickIcon : CrossIcon}
                    alt={isEnabled ? 'On' : 'Off'}
                />
            </Knob>
        </Switch>
    )
}
